export enum ExchangeResourceTypeEnum {
    Room = 0,
    Equipment = 1,
    Workspace = 2
}